var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"item menu-container"},[_c('the-menu')],1),_c('div',{staticClass:"item main-container m-hide"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }